import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@mui/material";
import { Check, CircleOutline, ClockOutline, LockOutline, } from "mdi-material-ui";
import { TASK_STATUS } from "../../lib/getTasks.js";
export const StatusTasksTooltip = ({ tasks }) => (_jsx(_Fragment, { children: tasks.map((task) => {
        const Icon = task.status === TASK_STATUS.completed
            ? Check
            : task.status === TASK_STATUS.pendingApproval
                ? ClockOutline
                : task.status === TASK_STATUS.future
                    ? LockOutline
                    : CircleOutline;
        return (_jsxs(Box, { sx: { display: "flex", alignItems: "center", gap: 0.75, py: 0.125 }, children: [_jsx(Icon, { color: "inherit", sx: { fontSize: 14, flexShrink: 0 } }), task.label] }, task.name));
    }) }));
//# sourceMappingURL=StatusTasksTooltip.js.map